// Adapted from https://github.com/ncoughlin/scroll-to-hash-element/blob/main/ScrollToHashElement.js
import { useEffect, FunctionComponent, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToHashElement: FunctionComponent = () => {
  const location = useLocation();
  const [element, setElement] = useState(null);

  /**
   * Check if the element in the hash exists. If not,
   * wait 250ms and then check again.
   */
  const checkForElement = () => {
    const hash = location.hash?.slice(1);

    if (hash) {
      const el = document.getElementById(hash);

      if (!el) {
        setTimeout(checkForElement, 250);
      } else {
        setElement(el);
      }
    }
  };

  useEffect(() => {
    setElement(null);
    checkForElement();
  }, [location]);

  useEffect(() => {
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [element]);

  return null;
};
